"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountStatusToJSON = exports.AdAccountStatusFromJSONTyped = exports.AdAccountStatusFromJSON = exports.AdAccountStatus = void 0;
/**
 * The status of the ad account.
 * @export
 */
exports.AdAccountStatus = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    GreyListed: 'GREY_LISTED',
    SuspendListed: 'SUSPEND_LISTED'
};
function AdAccountStatusFromJSON(json) {
    return AdAccountStatusFromJSONTyped(json, false);
}
exports.AdAccountStatusFromJSON = AdAccountStatusFromJSON;
function AdAccountStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdAccountStatusFromJSONTyped = AdAccountStatusFromJSONTyped;
function AdAccountStatusToJSON(value) {
    return value;
}
exports.AdAccountStatusToJSON = AdAccountStatusToJSON;
